import { Link } from "react-router-dom";
import { ArrowRight, Wand2 } from "lucide-react";
import { Browser, MOCKUPS } from "@/components/site/SiteMockups";
import { HOME_TEXT as T } from "@/data/content";

const Shop = MOCKUPS.botteghe;

export default function PreviewCta() {
  return (
    <section className="bg-p-preview relative overflow-hidden py-12 md:py-20">
      <div className="wrap relative grid items-center gap-10 lg:grid-cols-2">
        <div>
          <span className="chip border-blue-200 bg-white/80 text-blue-700"><Wand2 className="h-3.5 w-3.5" />Il nostro plus</span>
          <h2 className="h-section mt-4">{T.preview_title} <span className="hl-light">{T.preview_highlight}</span></h2>
          <p className="mt-4 max-w-lg text-slate-700">{T.preview_text}</p>
          <Link to="/richiedi-anteprima" data-testid="preview-cta-btn" className="btn-primary mt-7">{T.preview_cta} <ArrowRight className="h-4 w-4" /></Link>
          <p className="mt-3 text-xs text-slate-600">Valutazione senza impegno, soggetta a conferma. Non è un sito completo gratuito.</p>
        </div>
        <div className="relative hidden sm:block" aria-hidden="true">
          <div className="grid grid-cols-2 gap-4">
            <div className="flex flex-col gap-2">
              <span className="text-[11px] uppercase tracking-[0.2em] text-slate-600">Prima</span>
              <div className="aspect-[16/11] rounded-xl border border-slate-300 bg-[#d9d9d9] p-3 font-serif text-[9px] text-[#333]">
                <div className="bg-[#003399] px-2 py-0.5 text-center text-white">BENVENUTI</div>
                <p className="mt-2 text-[#cc0000]">*** NOVITÀ!!! ***</p>
                <p className="mt-1">Scaricate il catalogo PDF (12 MB)…</p>
                <div className="mt-2 h-8 bg-[#bbb]" />
              </div>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-[11px] uppercase tracking-[0.2em] text-blue-700">Dopo</span>
              <Browser url="tua-attivita.it"><Shop /></Browser>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
